import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators, compose} from 'redux';
import { firebaseConnect, isLoaded } from 'react-redux-firebase'
import * as folioActions from '../../actions/folio-actions';

import Swipe from 'react-easy-swipe';
import PropTypes from 'prop-types';
import find from 'lodash/find';
import startCase from 'lodash/startCase';
import throttle from 'lodash/throttle';
import FolioNavigation from '../../components/FolioNavigation/index';
import Slides from '../../components/Slides/index';
import ImageProgressBar from '../../components/ImageProgressBar/index';
import classnames from 'classnames';

import '../../styles.scss';

class FolioContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedThumbnail: '',
      selectedProject: {
        slides: []
      },
      currentSlideNumber: 1,
      ticking: false,
      scrollSensitivitySetting: 30,
      slideDurationSetting: 1200,
      showFolioNavigation: true,
      supportsGrids: false,
      portrait: false,
      deviceType: window.innerWidth < 769 ? 'mobile' : 'desktop'
    };
  }


  componentDidMount() {
    const { actions, folio, match } = this.props;
    window.addEventListener("resize", this.throttleViewport, true);
    window.addEventListener("wheel", this.throttleParallaxScroll, true);
    //window.addEventListener("hashchange", this.handleHashChange, true);
    window.addEventListener("keydown", (e) =>  {
      const filteredSlides = this.getSlidesByDevice(this.state.selectedProject.slides, this.state.deviceType);

      if ((e.which === 40 || e.which === 39 || e.which === 32) &&
        folio.currentSlideNumber < filteredSlides.length + 1) {
          actions.setCurrentSlide(folio.currentSlideNumber + 1);
      }
      if ((e.which === 37 || e.which === 38) && folio.currentSlideNumber > 1) {
        actions.setCurrentSlide(folio.currentSlideNumber - 1);
      }
      if (e.which === 13) {
        actions.toggleFolioNav()
      }
    }, false);
    if (this.containerTest && typeof this.containerTest.style.grid === 'string') {
      this.setState(() => ({ supportsGrids: true }));
    }

    if (match && match.params && match.params.title) {
      const selectedThumbnail = startCase(match.params.title).replace(/And/gi, 'and');
      this.setState(() => ({ selectedThumbnail }));
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.throttleViewport, true);
    window.removeEventListener('wheel', this.throttleParallaxScroll, true);
    //window.removeEventListener('handleHashChange', this.handleHashChange, true);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.selectedThumbnail !== '' && prevState.selectedThumbnail !== this.state.selectedThumbnail) {
      this.setState(()=> ({ slidesEnabled: false }));
      this.setCurrentSlide(1);
    }

    if (this.props.projects !== prevProps.projects) {
      this.setSelectedProject(this.state.selectedThumbnail);
    }
  }
  //
  // handleHashChange = (e) => {
  //   const prev = e.oldURL;
  //   const next = e.newURL;
  //   if (e.newURL.includes('slide-')) {
  //     const prevSlideRegex = new RegExp('#slide.(\\d*$)', 'gm');
  //     const nextSlideRegex = new RegExp('#slide.(\\d*$)', 'gm');
  //     const oldSlideNumber = prevSlideRegex.exec(e.oldURL);
  //     const newSlideNumber = nextSlideRegex.exec(e.newURL);
  //     console.log('**', oldSlideNumber, newSlideNumber);
  //     if (oldSlideNumber && newSlideNumber && newSlideNumber < oldSlideNumber) {
  //       const projectRegex = new RegExp('[^\\/#]+(?=#|$)', 'gm');
  //       console.log(projectRegex.exec(e.newURL));
  //       this.props.actions.toggleFolioNav();
  //     }
  //   }
  // };

  setCurrentSlide = (slideNumber) => {
    this.setState({ currentSlideNumber: slideNumber })
  };

  parallaxScroll = (e) => {
    const delta = e.wheelDelta;
    if (this.state.ticking !== true) {
      if (delta <= -this.state.scrollSensitivitySetting) { this.downScroll(); }
      if (delta >= this.state.scrollSensitivitySetting) { this.upScroll(); }
    }
  };

  adjustViewport = () => {
    if (window.innerHeight / window.innerWidth > .6) {
      this.setState( () => ({ portrait: true }));
    } else {
      this.setState( () => ({ portrait: false }));
    }
  };

  throttleParallaxScroll = throttle(this.parallaxScroll, 60);
  throttleViewport = throttle(this.adjustViewport, 60);

  setSelectedProject = (name) => {
    let selectedProject = {};

    if (isLoaded(this.props.projects)) {
      selectedProject = find(this.props.projects, { name: name }) || {};

      const filteredSlides = this.getSlidesByDevice(selectedProject.slides, this.state.deviceType);

      let photos = [];
      filteredSlides &&
      filteredSlides.length &&
      filteredSlides.forEach((slide) => {
        slide.layout &&
        slide.layout.columns &&
        slide.layout.columns.length &&
        slide.layout.columns.forEach((col) => {
          col.photo && photos.push(col.photo);
        })
      });
      this.setState( () => ({ selectedProjectPhotos: photos }));
      const slideImageUrls = [];
      selectedProject.slides &&
      selectedProject.slides.map((slide) => {
        slide.layout.columns.map((column) => {
          column.photo &&
          slideImageUrls.push(column.photo.url);
        })
      });
      this.setState(() => ({ selectedProject: selectedProject }));
    }
  };



  downScroll = () => {
    if (this.props.match.url === '/folio') {
      return
    }
    this.setState({ ticking: true, scrollDirection: 'down' });

    const filteredSlides = this.getSlidesByDevice(this.state.selectedProject.slides, this.state.deviceType);
    const hasCredit = this.state.selectedProject
        && this.state.selectedProject.credits
        && this.state.selectedProject.credits.enabled || 0;

    if (this.state.currentSlideNumber < filteredSlides.length + hasCredit) {
      this.setCurrentSlide(this.state.currentSlideNumber + 1);
    }
    this.slideDurationTimeout(this.state.slideDurationSetting);
  };

  upScroll = () => {
    if (this.props.match.url === '/folio') {
      return
    }
    this.setState({ ticking: true, scrollDirection: 'up' });
    if (this.state.currentSlideNumber > 1) {
      //this.props.actions.setCurrentSlide(this.getCurrentSlide() - 1);
      this.setCurrentSlide(this.state.currentSlideNumber - 1);
    }
    this.slideDurationTimeout(this.state.slideDurationSetting);
  };

  onSwipeMove = (position) => {
    if (position.y < -25 ) {
      this.setState(() => ({ swipeDirection: 'up' }))
    }
    if (position.y > 25) {
      this.setState(() => ({ swipeDirection: 'down' }))
    }
    return this.props.match.url !== '/folio';
  };

  onSwipeEnd = () => {
    this.state.swipeDirection === 'up' ? this.downScroll() : this.upScroll();
    this.setState(() => ({ swipeDirection: '' }))
  };

  slideDurationTimeout = (duration) => {
    setTimeout(() => { this.setState(() => ({ticking: false})); }, duration);
  };

  handleFolioNavClick = ({ title }) => {
    this.setState(() => ({ selectedThumbnail: title }));
    this.setSelectedProject(title)
  };

  getSlidesByDevice = (slides, deviceType) => {
    return slides ? slides.filter((slide) =>
        slide.layout.device === 'both' ||
        slide.layout.device === deviceType ||
        !slide.layout.device) : [];
  };

  getCurrentSlide = () => {
    return this.state.currentSlideNumber
    //return Number(this.props.location.hash.split('#slide-')[1]) || 1;
  };

  render() {
    const { actions, firebase, projects, folio } = this.props;

    const currentSlideNumber = this.getCurrentSlide();
    const classes = classnames(
        ['wrapper--inner',
          { 'is-active': this.props.location && this.props.location.pathname === '/folio' }
        ]);
    let selectedProject = {};
    if (isLoaded(projects)) {
      selectedProject = find(projects, { name: this.state.selectedThumbnail, enabled: true }) || {};
    }
    const filteredSlides = this.getSlidesByDevice(selectedProject.slides, this.state.deviceType);
    const thumbnails = this.props.projects && Object.keys(projects).map((thumb) => ({
          title: projects[thumb].name,
          path: projects[thumb].thumbnailPath,
          enabled: projects[thumb].enabled,
          order: projects[thumb].order
    }));

    return (
        <Swipe onSwipeEnd={ this.onSwipeEnd } onSwipeMove={ this.onSwipeMove }>
          <div ref={ el => this.containerTest = el } className={ classes }>
            <FolioNavigation disableSlides={ () => { this.setState(() => ({ slidesEnabled: false })) } }
                             resetFolio={ actions.resetFolio }
                             firebase={ firebase }
                             toggleFolioNav={ actions.toggleFolioNav }
                             handleClose={ actions.toggleFolioNav }
                             handleClick={ this.handleFolioNavClick }
                             thumbs={ thumbnails }
            />
            { this.state.selectedProjectPhotos && this.state.selectedProjectPhotos.length > 0 &&
            <ImageProgressBar handleFinishLoading={ () => { this.setState(() => ({ slidesEnabled: true, selectedProjectPhotos: false })) } }
                              photos={ this.state.selectedProjectPhotos }
                              totalImages={ this.state.selectedProjectPhotos.length }
            /> }
            { selectedProject.name &&
              <Slides credits={ selectedProject.credits }
                      creditTitle={ selectedProject.credits && selectedProject.credits.title }
                      currentSlideNumber={ currentSlideNumber }
                      folioNavigationEnabled={ folio.folioNavigationEnabled }
                      id={ this.state.selectedThumbnail }
                      overview={ selectedProject.overview }
                      quote={ selectedProject.quote }
                      // setCurrentSlide={ (index) => { actions.setCurrentSlide(index) } }
                      setCurrentSlide={ this.setCurrentSlide }
                      slides={ filteredSlides }
                      slidesEnabled={ this.state.slidesEnabled }
                      title={ selectedProject.overview.title ? selectedProject.overview.title : selectedProject.name }
                      toggleFolioNav={ actions.toggleFolioNav }
                      totalSlides={ selectedProject.credits && selectedProject.credits.enabled ?
                          filteredSlides && filteredSlides.length :
                          filteredSlides && filteredSlides.length - 1 }
                      supportsGrids={ this.state.supportsGrids }
                      deviceType={ this.state.deviceType }
                      location={ this.props.location }
              /> }
          </div>
        </Swipe>
    );
  }
}

FolioContainer.propTypes = {
  actions: PropTypes.object.isRequired,
  credits: PropTypes.string,
  creditTitle: PropTypes.string,
  currentSlideNumber: PropTypes.number,
  id: PropTypes.number,
  overview: PropTypes.object,
  quote: PropTypes.object,
  folioNavigationEnabled: PropTypes.bool,
  firebase: PropTypes.object.isRequired,
  folio: PropTypes.object.isRequired,
  projects: PropTypes.array,
  setCurrentSlide: PropTypes.func,
  slides: PropTypes.array,
  slidesEnabled: PropTypes.bool,
  title: PropTypes.string,
  toggleFolioNav: PropTypes.func,
  totalSlides: PropTypes.number
};

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(folioActions, dispatch)
  }
}

export default compose(
    firebaseConnect(['projects']),
    connect(
      (state) => ({
        folio: state.folio,
        projects: state.firebase.data.projects,
        auth: state.firebase.auth
      }), mapDispatchToProps
    )
)(FolioContainer)



// WEBPACK FOOTER //
// ./src/containers/folio/folio.js